import React from 'react';
import { FaEnvelope, FaGoogle, FaInstagram, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import useSiteContent from '../hooks/useSiteContent';
import { siteLinks } from '../content/siteContent';

const socialLinks = [
  { href: siteLinks.instagramUrl, label: 'Instagram', icon: FaInstagram },
  { href: siteLinks.googleUrl, label: 'Google', icon: FaGoogle },
];

export default function ContactPage() {
  const { siteContent } = useSiteContent();

  return (
    <main className="page">
      <section className="page-section page-section--intro">
        <div className="section-heading section-heading--centered">
          <span className="section-heading__eyebrow">{siteContent.contact.tag}</span>
          <h1>{siteContent.contact.title}</h1>
          <p>{siteContent.contact.text}</p>
        </div>
      </section>

      <section className="page-section split-grid split-grid--hero">
        <div className="content-card">
          <div className="content-card__body">
            <span className="section-heading__eyebrow">{siteContent.contact.bookingTitle}</span>
            <h2>{siteContent.contact.bookingTitle}</h2>
            <p>{siteContent.contact.text}</p>
          </div>
          <div className="calendly-frame-wrap">
            <iframe
              title="Booking calendar"
              src={`${siteLinks.consultationUrl}?hide_landing_page_details=1&hide_gdpr_banner=1`}
              className="calendly-frame"
            />
          </div>
        </div>

        <div className="content-card">
          <div className="content-card__body">
            <span className="section-heading__eyebrow">{siteContent.contact.infoTitle}</span>
            <h2>{siteContent.contact.infoTitle}</h2>
            <div className="info-list info-list--rich">
              <a href={siteLinks.emailHref}>
                <FaEnvelope />
                <span>{siteLinks.email}</span>
              </a>
              <a href={siteLinks.phoneHref}>
                <FaPhoneAlt />
                <span>{siteLinks.phone}</span>
              </a>
              <a href={siteLinks.mapsUrl} target="_blank" rel="noopener noreferrer">
                <FaMapMarkerAlt />
                <span>
                  {siteLinks.address1}
                  <br />
                  {siteLinks.address2}
                </span>
              </a>
            </div>
            <div className="social-inline">
              {socialLinks.map(({ href, label, icon: Icon }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer">
                  <Icon />
                  <span>{label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
